var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 6.66663L23.295 7.1616L23.7899 6.66663L23.295 6.17165L22.8 6.66663ZM1.2 18.6666L0.705025 18.1717L0.210051 18.6666L0.705025 19.1616L1.2 18.6666ZM0 7.36663H21.6V5.96663H0V7.36663ZM16.305 1.1616L22.305 7.1616L23.295 6.17165L17.295 0.171651L16.305 1.1616ZM22.305 6.17165L16.305 12.1717L17.295 13.1616L23.295 7.1616L22.305 6.17165ZM24 17.9666H2.4V19.3666H24V17.9666ZM6.70503 12.1717L0.705025 18.1717L1.69497 19.1616L7.69497 13.1616L6.70503 12.1717ZM0.705025 19.1616L6.70503 25.1616L7.69497 24.1717L1.69497 18.1717L0.705025 19.1616Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.771b9c28.svg";
export { ForwardRef as ReactComponent };